<template>
  <div>
    <div class="nav-wrapper">
      <the-nav-bar :title="$t('orders.name')" class="nav-bar" />
      <md-tab-bar
        :items="tabItems"
        @change="onTabChange"
        v-model="currentTab"
      ></md-tab-bar>
    </div>
    <div class="filter">
      <md-input-item
        v-model.trim="filterKey"
        type="text"
        :placeholder="$t('exchange.filterPlaceholder')"
        @change="onFilterKeyChanged"
      >
        <div class="input-item-left row-center" slot="left">
          <md-icon name="search" size="lg" color="currentColor"></md-icon>
        </div>
      </md-input-item>

      <div class="time-change-box" @click="goTimeChange">
        <span>{{ startTime }} - {{ endTime }}</span>
        <span class="icon-dropdown"></span>
      </div>
    </div>
    <div class="body-wrapper">
      <div class="loading-wrapper row-center" v-if="!isLoaded">
        <md-activity-indicator type="roller" color="currentColor">
          <span class="text">Loading...</span>
        </md-activity-indicator>
      </div>
      <div class="empty-wrapper row-center" v-else-if="orderList.length <= 0">
        <span class="text">{{ $t('orders.noRecords') }}</span>
      </div>
      <md-scroll-view
        v-else
        ref="scrollView"
        class="scroll-view"
        auto-reflow
        :scrolling-x="false"
        @end-reached="onReachEnd"
      >
        <div class="list-wrapper">
          <div
            class="list-item"
            v-for="item in orderList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="list-item-header row-justify">
              <div class="item-header-left row-center">
                <img
                  :src="item.assetIconUrl"
                  :alt="item.assetSymbol"
                  class="item-header-icon"
                />
                <span>
                  {{
                    `${
                      item.type == 'buy' ? $t('common.buy') : $t('common.sell')
                    } ${item.assetSymbol}`
                  }}
                </span>
              </div>
              <div class="item-header-right col-align-end">
                <span class="status" :class="item.orderStatus">
                  {{ $t(`orders.${item.orderStatus}`) }}
                </span>
                <span class="date">{{ formatTime(item.createdAt) }}</span>
              </div>
            </div>
            <div class="list-item-body">
              <div class="row-justify-center body-item avatar-item">
                <div class="body-item-left row-center">
                  <img :src="item.traderAvatar" class="avatar" />
                  <span class="strong">{{ item.traderName }}</span>
                </div>
                <div
                  class="body-item-right row-center"
                  @click.stop="goRelatedAds(item.traderId)"
                >
                  <span>{{ $t('related.view') }}</span>
                  <md-icon name="arrow-right" size="md"></md-icon>
                </div>
              </div>
              <div
                class="row-justify-center body-item"
                @click.stop="$copyText(item.orderId)"
              >
                <div class="body-item-left">
                  {{ $t('orderDetail.orderNumber') }}
                </div>
                <div class="body-item-right row-center">
                  {{ item.orderId }}
                  <svg class="icon-copy">
                    <use xlink:href="#icon-copy" />
                  </svg>
                </div>
              </div>
              <!-- <div class="row-justify-center body-item">
                <div class="body-item-left">
                  {{
                    item.type === 'sell'
                      ? $t('orderDetail.buyer')
                      : $t('orderDetail.seller')
                  }}
                </div>
                <div class="body-item-right">{{ item.traderName }}</div>
              </div> -->
              <div class="row-justify-center body-item">
                <div class="body-item-left">{{ $t('orders.amount') }}</div>
                <div class="body-item-right">
                  <span class="num">{{ item.assetAmount | noSci }}</span>
                  <span class="unit">{{ item.assetSymbol }}</span>
                </div>
              </div>
              <div class="row-justify-center body-item">
                <div class="body-item-left">{{ $t('orders.price') }}</div>
                <div class="body-item-right">
                  <span class="num">{{ item.assetPrice }}</span>
                  <span class="unit">
                    {{ `${item.currencySymbol}/${item.assetSymbol}` }}
                  </span>
                </div>
              </div>
              <div class="row-justify body-item">
                <div class="body-item-left">{{ $t('orders.total') }}</div>
                <div class="body-item-right">
                  <span class="num">{{ item.totalPrice }}</span>
                  <span class="unit">{{ item.currencySymbol }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <md-scroll-view-more
          slot="more"
          class="scroll-more"
          :is-finished="isFinished"
          :loading-text="$t('common.loading')"
          :finished-text="$t('common.noMore')"
        ></md-scroll-view-more>
      </md-scroll-view>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  ScrollView,
  ScrollViewMore,
  Toast,
  TabBar,
  Swiper,
  SwiperItem,
  ActivityIndicator,
  InputItem,
  Icon,
} from 'mand-mobile';
import getOrders from '@/api/get-orders';
import moment from 'moment';
import noSci from '@/utils/no-sci.js';
export default {
  components: {
    TheNavBar,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
    [TabBar.name]: TabBar,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
    [ActivityIndicator.name]: ActivityIndicator,
    [InputItem.name]: InputItem,
    [Icon.name]: Icon,
  },
  filters: {
    noSci,
  },
  data() {
    return {
      isLoaded: false,
      isLoading: false,
      isFinished: false,
      orderList: [],
      currentPage: 1,
      sumPerPage: 20,
      scrollTop: 0,
      currentTab: '',
      filterKey: '',
      startTime: moment().subtract(6, 'days').format('YYYY/MM/DD'),
      endTime: moment().format('YYYY/MM/DD'),
      timeout: null,
      //
      // all: {
      //   list: [],
      //   currentPage: 1,
      //   isFinished: false,
      //   isLoaded: false,
      //   scrollTop: 0,
      //   isLoading: false,
      // },
      // done: {
      //   list: [],
      //   currentPage: 1,
      //   isFinished: false,
      //   isLoaded: false,
      //   scrollTop: 0,
      //   isLoading: false,
      // },
      // pending: {
      //   list: [],
      //   currentPage: 1,
      //   isFinished: false,
      //   isLoaded: false,
      //   scrollTop: 0,
      //   isLoading: false,
      // },
      // cancel: {
      //   list: [],
      //   currentPage: 1,
      //   isFinished: false,
      //   isLoaded: false,
      //   scrollTop: 0,
      //   isLoading: false,
      // },
    };
  },
  beforeRouteLeave(to, from, next) {
    // ...
    if (!['orderDetail', 'orderTimeChange', 'related'].includes(to.name)) {
      const { data, parent, componentOptions, key } = this.$vnode;
      if (this.$vnode && data && data.keepAlive) {
        if (
          parent &&
          parent.componentInstance &&
          parent.componentInstance.cache
        ) {
          if (componentOptions) {
            const cacheCompKey = !key
              ? componentOptions.Ctor.cid +
                (componentOptions.tag ? `::${componentOptions.tag}` : '')
              : key;
            const cache = parent.componentInstance.cache;
            const keys = parent.componentInstance.keys;
            const index = keys.findIndex(k => k == cacheCompKey);
            if (index > -1 && cache[cacheCompKey]) {
              keys.splice(index, 1);
              delete cache[cacheCompKey];
            }
          }
        }
      }
      this.$destroy();
    }
    if (to.name === 'orderTimeChange') {
      this.$store.commit('setOrderTemp', {
        startTime: this.startTime,
        endTime: this.endTime,
      });
    } else {
      this.$store.commit('setOrderTemp', {
        startTime: '',
        endTime: '',
      });
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        vm.$store.state.orderTempState.startTime != '' &&
        vm.$store.state.orderTempState.endTime != ''
      ) {
        vm.startTime = vm.$store.state.orderTempState.startTime;
        vm.endTime = vm.$store.state.orderTempState.endTime;
        vm.loadMore(true);
      }
    });
  },
  mounted() {},
  computed: {
    tabItems() {
      return 'all,done,pending,cancel'.split(',').map(key => {
        return {
          name: key,
          label: this.$t(`orders.${key}`),
        };
      });
    },
    // newOrderList() {
    //   var _this = this;
    //   var Newitems = [];
    //   _this.orderList.map(function(item) {
    //     if (
    //       item.orderId.search(_this.filterKey) != -1 ||
    //       item.otherName.search(_this.filterKey) != -1 ||
    //       item.assetSymbol.search(_this.filterKey) != -1
    //     ) {
    //       Newitems.push(item);
    //     }
    //   });
    //   return Newitems;
    // },
  },
  // mounted() {
  //   Toast.loading(this.$t('common.loading'));
  //   this.loadMore()
  //     .then(data => {
  //       Toast.hide();
  //       this.isLoaded = true;
  //       if (!data.links || !data.links.next) {
  //         this.isFinished = true;
  //       }
  //       this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
  //     })
  //     .catch(err => {
  //       Toast.hide();
  //       this.isLoaded = true;
  //       Toast.failed(`${this.$t('error.occur')}${err.message}`);
  //     });
  // },
  activated() {
    // scrollTo 需要长一点时间才能正确滚回原位置
    setTimeout(() => {
      this.$refs.scrollView &&
        this.$refs.scrollView.scrollTo(0, this.scrollTop, false);
    }, 100);
  },
  methods: {
    onFilterKeyChanged() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.loadMore(true)
          .then(data => {
            if (!data.links || !data.links.next) {
              this.isFinished = true;
            }
            this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
          })
          .catch(err => {
            Toast.failed(`${this.$t('error.occur')}${err.message}`);
          });
      }, 3000);
    },
    loadMore(isRefresh = false) {
      this.isLoading = true;
      if (isRefresh) {
        this.currentPage = 1;
      }
      return getOrders(
        this.currentPage,
        this.sumPerPage,
        this.currentTab === 'all' ? '' : this.currentTab,
        // moment(this.startTime + ' 00:00:00').format('YYYY-MM-DD hh:mm:ss'),
        // moment(this.endTime + ' 00:00:00').format('YYYY-MM-DD hh:mm:ss'),
        Date.parse(this.startTime + ' 00:00:00')
          .toString()
          .substr(0, 10),
        Date.parse(this.endTime + ' 23:59:59')
          .toString()
          .substr(0, 10),
        this.filterKey,
      )
        .then(data => {
          this.isLoading = false;
          const d = data.data;
          const arr = [];
          if (Array.isArray(d)) {
            d.forEach(item => {
              arr.push({
                id: item.id,
                orderId: item.orderId,
                type: item.type,
                orderStatus: item.orderStatus,
                createdAt: item.createdAt * 1000,
                assetSymbol: item.asset.symbol,
                assetPrice: +item.payAssetPrice,
                totalPrice: +item.allPrice,
                assetIconUrl: item.asset.iconUrl,
                assetAmount: +item.assetAmount,
                currencySymbol: item.legalCurrency.symbol,
                traderAvatar:
                  item.otherAvatarUrl || require('@/images/avatar-default.svg'),
                traderName:
                  item.type === 'buy'
                    ? `${item.payerName} (${item.payerTrueName})`
                    : `${item.receiverName} (${item.receiverTrueName})`,
                traderId: item.type === 'buy' ? item.payerId : item.receiverId,
              });
            });
          }
          this.currentPage += 1;
          if (isRefresh) {
            this.orderList = arr;
          } else {
            this.orderList = this.orderList.concat(arr);
          }
          this.$refs.scrollView && this.$refs.scrollView.reflowScroller();
          if (isRefresh) {
            this.$refs.scrollView &&
              this.$refs.scrollView.scrollTo(0, 1, false);
          }
          return Promise.resolve(data);
        })
        .catch(err => {
          this.isLoading = false;
          return Promise.reject(err);
        });
    },
    onReachEnd() {
      if (this.isFinished || this.isLoading) return;
      this.loadMore()
        .then(data => {
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          }
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    },
    formatTime(unix) {
      return moment(unix).format('YYYY-MM-DD HH:mm:ss');
    },
    formatTime2(unix) {
      return moment(unix).format('YYYY/MM/DD');
    },
    goDetail(id) {
      this.scrollTop =
        (this.$refs.scrollView && this.$refs.scrollView.getOffsets().top) || 0;
      this.$router.push(`/mine/orders/orderDetail?id=${id}`);
    },
    goTimeChange() {
      this.$router.push('/mine/orders/orderTimeChange');
      // window.location.href = '/#/mine/orders/orderTimeChange';
    },
    onTabChange(item) {
      this.currentTab = item.name;
      this.isLoaded = false;
      this.isFinished = false;
      this.loadMore(true)
        .then(data => {
          this.isLoaded = true;
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          }
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          this.isLoaded = true;
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    },
    goRelatedAds(id) {
      this.$router.push({
        path: '/exchange/related',
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.nav-wrapper {
  background: #fff;

  .md-tab-bar {
    margin-top: 2.13vw;

    & >>> {
      .md-tab-bar-item {
        font-weight: normal;

        &.is-active {
          font-weight: bold;
        }
      }
    }
  }
}

.body-wrapper {
  position: absolute;
  // absolute-pos(25.6vw);
  absolute-pos(52vw);
  background: #F8FBFC;
}

.loading-wrapper, .empty-wrapper {
  min-height: 40vw;
  color: color-primary;

  >>> .md-activity-indicator-svg {
    width: 6.4vw !important;
    height: 6.4vw !important;
  }

  .text {
    font-size: 3.73vw;
    color: #84969C;
  }
}

// .empty-wrapper {
// min-height: 30vw;
// font-size: 3.73vw;
// color: #84969C;
// }
.list-item {
  margin-top: 2.13vw;
  background: #fff;
}

.list-item-header {
  padding: 4.8vw 4.8vw 2.13vw;
  border-bottom: 0.27vw solid #EAF1F3;

  .item-header-left {
    font-size: 3.73vw;
    font-weight: bold;
    color: color-text-base;

    .item-header-icon {
      margin-right: 2.13vw;
      icon-size(6.4vw);
    }
  }

  .item-header-right {
    color: #84969C;

    .status {
      line-height: 6.4vw;

      &.done {
        color: #1b6fdc;
      }

      &.pending {
        color: #dc521b;
      }
    }

    .date {
      font-size: 2.67vw;
    }
  }
}

.list-item-body {
  padding: 4.8vw;

  .body-item {
    color: #84969C;
    height: 5.33vw;

    &:last-child {
      color: color-text-base;

      .num {
        font-size: 4.27vw;
        font-weight: bold;
      }
    }

    .icon-copy {
      margin-left: 1.33vw;
      width: 4.8vw;
      height: 4.8vw;
      vertical-align: middle;
    }
  }

  .avatar-item {
    margin-bottom: 2.13vw;

    .avatar {
      margin-right: 2.93vw;
      width: 5.33vw;
      height: 5.33vw;
      border-radius: 50%;
    }

    .strong {
      font-size: 3.73vw;
      font-weight: bold;
      color: color-text-base;
    }

    .body-item-right {
      font-size: 3.2vw;
      color: color-primary;
    }
  }

  .unit {
    margin-left: 1.07vw;
    font-size: 2.67vw;
  }
}

.scroll-more {
  padding-bottom: 20vw;
  margin-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  margin-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
}

.filter {
  padding: 4.8vw;

  .md-input-item {
    border: 0.27vw solid #eaf1f3;
    padding: 0 2.67vw;
    border-radius: 2.67vw;
    background: #f8fbfc;

    & >>> {
      .md-field-item-content:before {
        content: none;
      }

      .md-field-item-left {
        margin-right: 5.33vw;
        color: #B4C2C7;
      }
    }
  }
}

.time-change-box {
  font-size: 2.4vw;
  color: #1b6fdc;
  line-height: 16px;
  margin-top: 4vw;
  display: flex;
  align-items: center;

  .icon-dropdown {
    width: 0;
    height: 0;
    border: 1.07vw solid transparent;
    border-top-color: #bcc7cb;
    border-bottom: none;
    transform: rotateZ(0deg);
    transition: transform 0.2s linear;
    margin-left: 1.07vw;
  }
}
</style>
